export default __webpack_public_path__ + "static/media/color-palette.1a45643b.png";